/**
 * @fileoverview Filling the server's What to plant words (E19): the search's closing lines carry {query} and {count},
 * the Add sheet's heading and button {plant}; the server says the sentence, the app puts in what she typed or tapped.
 *
 * Where: CropSearch, AddCropSheet.
 *
 * @module fillWords
 */

/**
 * A server sentence with its {placeholders} filled.
 *
 * @param text - The sentence.
 * @param values - The placeholders' values.
 * @returns The sentence.
 */
export function fill(text: string, values: Record<string, string | number>): string {
  return Object.entries(values).reduce((out, [key, value]) => out.split(`{${key}}`).join(String(value)), text);
}
